import React, { useRef, useEffect, useContext } from "react";
import { bootstrapGame, TowerGameClass } from "./game";
import { Store } from "./App";

interface Props {
  onComplete: (points: number) => void;
}

export function TowerGame(props: Props) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const store = useContext(Store);
  const haveChoicesLoaded = !!store.choices;
  useEffect(() => {
    if (canvasRef.current && haveChoicesLoaded) {
      bootstrapGame(
        canvasRef.current,
        TowerGameClass,
        props.onComplete,
        store.choices["10"]
      );
    }
    //eslint-disable-next-line
  }, [canvasRef.current, haveChoicesLoaded]);
  return <canvas ref={canvasRef} />;
}
